import '../../style';
import './index.less';



// WEBPACK FOOTER //
// ./components/photo-preview/style/index.tsx